import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import EnvironmentalBg from "images/environmental.png";

export const EnvironmentalStewardship = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query EnvironmentalStewardshipHeroImageQuery {
          file(relativePath: { eq: "environmental.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt="Someone charging their electric car"
          css={`
            + picture > img,
            img {
              object-position: 78% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 68% 50%;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: 69% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 32px 38px 25px 38px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 767px) {
          padding: 38px 46px 40px 50px;
          width: 360px;
        }
        @media screen and (min-width: ${getSize("tablet768")}) {
          width: 384px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 39px 46px 44px 50px;
          width: 420px;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          width: 439px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 552px;
        }
      `}
    >
      <Header2>
        {"Environmental Stewardship"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize("desktop1200")}) {
              margin-top: 27px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          margin-top: 20px;
          @media screen and (min-width: ${getSize("tablet720")}) {
            margin-top: 18px;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            width: 283px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            margin-top: 23px;
            width: 341px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            width: 392px;
          }
        `}
      >
        {
          "Smart Homes can be eco-friendly without sacrifice to your quality of living. Homeowners can view available green energy production, dynamically control consumption and reduce their overall carbon footprint."
        }
      </Paragraph>
    </Card>
  </Section>
);
